import { useURLSearchParamsList } from "widgets/hooks";
import { toSafeInt } from "widgets/utils";

const useURLViewID = (): number | null => {
  const viewIdArray = useURLSearchParamsList("viewid");
  if (viewIdArray == null) return null;
  return toSafeInt(viewIdArray[0]);
};

export { useURLViewID };
